import React from 'react';

const PrimaryButton = ({ children, onClick, className = '' }) => {
    return (
        <button
            onClick={onClick}
            className={`px-3 py-2 text-sm sm:px-6 sm:py-3 sm:text-base bg-earth-900 text-earth-50 hover:bg-earth-700 hover:text-earth-50 font-semibold rounded-3xl transition-colors duration-200 ${className}`}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;

